module.exports = __webpack_public_path__ + "static/media/logo.f2699e40.png";